export const questionTypesText = Object.freeze({
    TEXT: "Texte",
    CHOICE: "Choix",
    CHOICE_MULTIPLE: "Choix multiple",
    RATING: "Score",
    INTEGER: "Nombre",
});

export const questionTypesColor = Object.freeze({
    TEXT: "blue",
    CHOICE: "violet",
    CHOICE_MULTIPLE: "teal",
    RATING: "yellow",
    INTEGER: "orange",
});

export const questionTypesIcon = Object.freeze({
    TEXT: "comment",
    CHOICE: "square",
    CHOICE_MULTIPLE: "clone",
    RATING: "star",
    INTEGER: "sort numeric descending",
});

export const chartRatesColours = [
    '#FA6250',
    '#F59B6A',
    '#EBD56A',
    '#9DD455',
    '#44AF69',
]

export const ratingFields = [
    {
        name: 'global_rating',
        icon: 'star',
        title: 'Note globale',
    },
    {
        name: 'food_rating',
        icon: 'utensils',
        title: 'Nourriture',
    },
    {
        name: 'service_rating',
        icon: 'glass martini',
        title: 'Service',
    },
    {
        name: 'atmosphere_rating',
        icon: 'smile',
        title: 'Ambiance',
    },
    {
        name: 'quality_price_rating',
        icon: 'money bill alternate outline',
        title: 'Qualité-prix',
    },
];


// WEBPACK FOOTER //
// ./src/constants/feedbacks.js